import {
	GET_HISTORICAL_ALARMS,
	GET_HISTORICAL_ALARMS_FAIL,
	GET_HISTORICAL_ALARMS_SUCCESS,
	SWITCH_HIST_ALARMS_REQUEST_GET,
	SWITCH_HIST_ALARMS_RESPONSE_GET_FAIL,
	SWITCH_HIST_ALARMS_RESPONSE_GET_SUCCESS,
} from '../../constants/maintenance/historicalAlarmsConstants';

/**
 * Reducer function for managing historical alarms list.
 *
 * @param {object} state - Current state of the historical alarms list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */

export const historicalAlarmsReducer = (
	state = { historicalAlarms: [] },
	action
) => {
	switch (action.type) {
		case GET_HISTORICAL_ALARMS:
			return {
				...state,
				loading: true,
			};
		case GET_HISTORICAL_ALARMS_SUCCESS:
			return {
				...state,
				loading: false,
				historicalAlarms: action.payload,
			};
		case GET_HISTORICAL_ALARMS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};

export const switchAlarmsEventListReducer = (state = { switchAlarmsEvent: {} }, action) => {
	switch (action.type) {
	  case SWITCH_HIST_ALARMS_REQUEST_GET:
		return {
		  ...state,
		  loading: true,
		};
	  case SWITCH_HIST_ALARMS_RESPONSE_GET_SUCCESS:
		return {
		  ...state,
		  loading: false,
		  switchAlarmsEvent: action.payload,
		};
	  case SWITCH_HIST_ALARMS_RESPONSE_GET_FAIL:
		return {
		  ...state,
		  loading: false,
		  error: action.payload,
		};
	  default:
		return state;
	}
  };
